import { useLocation } from "wouter";
import { RotateCcw } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface TopBarProps {
  companyName: string;
  displayName: string;
  initials: string;
  onLogout: () => void;
}

export function TopBar({ companyName, displayName, initials, onLogout }: TopBarProps) {
  const [, setLocation] = useLocation();

  return (
    <div className="sticky top-0 z-20 hidden h-16 items-center justify-between border-b border-border bg-card px-6 md:flex md:px-8">
      {/* Static label, not a real dropdown — this app is one workspace per login;
          no company/assessment switcher exists in the data model. */}
      <div className="rounded-md border border-border bg-background px-3 py-1.5 text-sm font-semibold text-foreground">
        {companyName}
      </div>

      <div className="flex items-center gap-3">
        <button
          type="button"
          disabled
          title="Available once scoring is connected"
          className="flex cursor-not-allowed items-center gap-1.5 rounded-md border border-border px-3 py-1.5 text-sm text-muted-foreground opacity-70"
        >
          <RotateCcw className="h-3.5 w-3.5" />
          Re-run assessment
        </button>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="flex h-8 w-8 items-center justify-center rounded-full border border-border bg-secondary text-xs font-semibold text-secondary-foreground focus:outline-none focus-visible:ring-1 focus-visible:ring-ring">
              {initials}
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" sideOffset={8} className="w-48">
            <DropdownMenuLabel className="truncate text-xs font-medium">{displayName}</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem className="cursor-pointer" onClick={() => setLocation("/settings")}>
              Settings
            </DropdownMenuItem>
            <DropdownMenuItem className="cursor-pointer" onClick={onLogout}>
              Logout
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
}
